import React from 'react'
//third party
import { BrowserRouter } from "react-router-dom";

// mine
import ReactToastifyMiddleware from './frontEndMiddleware';


const BrowserRouterMiddleware = () => {
    return (
        <BrowserRouter>
            <ReactToastifyMiddleware />
        </BrowserRouter>
    )
}


export default BrowserRouterMiddleware